module.exports = __webpack_public_path__ + "img/work_order_2.fd14e0a7.png";